import { render, staticRenderFns } from "./occupancy-product.vue?vue&type=template&id=f392c97a&scoped=true"
import script from "./occupancy-product.vue?vue&type=script&lang=js"
export * from "./occupancy-product.vue?vue&type=script&lang=js"
import style0 from "./occupancy-product.vue?vue&type=style&index=0&id=f392c97a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f392c97a",
  null
  
)

export default component.exports